import React from 'react';

/* mui */
import { makeStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
/* mui */

/* CONSTANTS */
const useStyles = makeStyles(theme => ({
  paper: {
    backgroundColor: "#fafafa",
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(2),
    textAlign: 'left',
    color: "#757575",
    boxShadow: "none"
  },
}));
/* CONSTANTS */

const wrapper = props => {

  /* mui */
  const classes = useStyles();
  /* mui */

  return <Paper className={classes.paper}>
    { props.children }
  </Paper>
}

export default wrapper;
